import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import './ConnectionStatus.css';

interface ConnectionStatusProps {
  className?: string;
}

/**
 * Displays a reconnection indicator when WebSocket is disconnected.
 * Shows nothing when connected.
 */
export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ className }) => {
  const { isConnected, isConnecting } = useSelector(
    (state: RootState) => state.message
  );

  // Don't show anything when connected
  if (isConnected) return null;

  return (
    <div className={`connection-status ${isConnecting ? 'connecting' : 'disconnected'} ${className || ''}`}>
      {isConnecting ? (
        <>
          <span className="connection-status-spinner" />
          <span className="connection-status-text">Reconnecting...</span>
        </>
      ) : (
        <>
          <span className="connection-status-icon">!</span>
          <span className="connection-status-text">Connection lost</span>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;
